export default __webpack_public_path__ + "static/media/be-human.c68f9813.svg";